import axios from "axios";
import AppConfig from "../config";

const baseURL = `${AppConfig.API_URL}/ContinuousMonitoring`;

const saveThreatForAllVendorAssessments = async (requestBody) => {
  try {
    let { data } = await axios.post(
      `${baseURL}/save-threat-for-all-vendor-assessments`,
      requestBody
    );
    if (data.success) {
      return data.result;
    } else {
      console.log(data.error);
      return null;
    }
  } catch (error) {
    console.log(error);
  }
};

const getReportedThreatHistory = async (id) => {
  try {
    let { data } = await axios.get(`${baseURL}/get-reported-threat-history`);
    if (data.success) {
      return data.result;
    } else {
      console.log(data.error);
      return null;
    }
  } catch (error) {
    console.log(error);
  }
};

export { saveThreatForAllVendorAssessments, getReportedThreatHistory };
